import { separatorPath } from 'utils/posterSeparator';

export const feedSize = { width: 979, height: 1222 };
export const storySize = { width: 1080, height: 1920 };

const backgrounds = [4, 1, 2, 3, 5];
export const backgroundCount = backgrounds.length;

const assets = {};
async function load(name, source) {
	const img = new Image();
	const load = new Promise((res, rej) => {
		img.onload = () => res(img);
		img.onerror = rej;
		img.crossOrigin = 'anonymous';
		img.src = source;
	});
	assets[name] = { source, img, load };
	return load;
}

export async function init() {
	const all = [];
	all.push(load(`tt`, `${__IMAGE_REGION_ROOT__}/photobooth/canvas_top_image.webp`));
	for (let i = 0; i < backgroundCount; i++) {
		all.push(load(`feed${i}`, `${__IMAGE_ROOT__}/photobooth/f${backgrounds[i]}.webp`));
		all.push(load(`story${i}`, `${__IMAGE_ROOT__}/photobooth/s${backgrounds[i]}.webp`));
	}
	all.push(
		document.fonts.load(`700 54px century-gothic`),
	);
	return Promise.all(all);
}

const p = (w, h) => 1 - (feedSize.height / feedSize.width * w) / h;
const corners = [
	[],
	[
		[[0, 0], [1, 0], [1, 1], [0, 1]],
	],
	[
		[[0, 0], [1, 0], [1, 1], [0, p]],
		[[0, p], [1, 1], [0, 1]],
	],
];
const getCornerValues = (corner, w, h) => corner.map(v => typeof v === 'function' ? v(w, h) : v);

export function drawCard(data, ctx, mode = 'feed') {
	const c = ctx.canvas;
	// ctx.clearRect(0, 0, c.width, c.height);
	ctx.fillStyle = 'black';
	ctx.fillRect(0, 0, c.width, c.height);
	const isSoloMode = data.sides.length <= 1;
	data.sides.forEach((side, index) => {
		ctx.save();
		const currentCorners = corners[data.sides.length]?.[index]?.map(v => getCornerValues(v, c.width, c.height));
		if (currentCorners?.length) {
			ctx.beginPath();
			currentCorners.forEach(([x, y]) => ctx.lineTo(x * c.width, y * c.height));
			ctx.closePath();
			ctx.clip();
		}
		const bg = assets[`${mode}${side.background}`];
		if (bg) {
			ctx.drawImage(bg.img, 0, 0, c.width, c.height);
		}
		if (side.photo) {
			ctx.translate(.5 * c.width, c.height - (feedSize.height / feedSize.width * c.width) * .5);
			if (mode === 'story') {
				const factor = storySize.width / feedSize.width;
				ctx.scale(factor, factor);
			}
			ctx.setTransform(ctx.getTransform().multiply(side.photoTransform));

			let width = side.photo.width;
			let height = side.photo.height;
			ctx.drawImage(
				side.photo,
				-width / 2,
				-height / 2,
				width,
				height
			);
		}
		ctx.restore();
	});
	if (!isSoloMode) {
		let lineStartY = p(c.width, c.height) * c.height;
		ctx.fillStyle = '#202020';
		ctx.save();
		const scaleY = c.height - lineStartY;
		ctx.scale(c.width, c.height - lineStartY);
		ctx.translate(0, lineStartY / scaleY);
		const path = new Path2D(separatorPath);
		ctx.fill(path);
		ctx.restore();
	}

	const maxTextWidth = .8 * c.width;
	const quote = data.quote?.replace('[name]', data.name || '').toUpperCase() || '';
	const fontSize = mode === 'feed' ? 54 : 66;
	ctx.font = `700 ${fontSize}px century-gothic, sans-serif`;
	ctx.textAlign = 'center';
	ctx.textBaseline = 'middle';
	ctx.fillStyle = '#e4eebf';
	ctx.strokeStyle = '#535648';
	ctx.lineWidth = fontSize / 8;
	ctx.lineJoin = 'round';
	ctx.miterLimit = 2;
	let lines = [];
	let line = '';
	const words = quote.trim().match(/(\n|[^\s]+)/g) || [];
	for (const word of words) {
		let testLine = line + word + ' ';
		if (word === '\n' || ctx.measureText(testLine).width > maxTextWidth) {
			lines.push(line.trim());
			line = word + ' ';
		} else {
			line = testLine;
		}
	}
	lines.push(line.trim());
	const lineHeight = fontSize * 1.4;
	let y = 0.95 * c.height - (lines.length - 1) * lineHeight;
	if (mode === 'story') {
		y = 0.33 * c.height - (lines.length - 1) / 2 * lineHeight;
	}
	lines.forEach(line => {
		ctx.strokeText(line, .5 * c.width, y, maxTextWidth);
		ctx.fillText(line, .5 * c.width, y, maxTextWidth);
		y += lineHeight;
	});

	const tt = assets.tt.img;
	let ttWidth = 400;
	let ttTop = 12;
	if (mode === 'story') {
		ttWidth = 760;
		ttTop = 48;
	}
	ctx.drawImage(tt, (c.width - ttWidth) / 2, ttTop, ttWidth, ttWidth / tt.width * tt.height);
}